export default "__VITE_ASSET__Cts8PLn6__"